export type AvatarsClassificationType = {
    [countryCode: string]: {
        theme: string;
        region: string;
        ethnicity: string;
    };
}

export const DefaultAvatarsClassification: AvatarsClassificationType = {
    "ae": {
        "theme": "Realistic",
        "region": "GCC",
        "ethnicity": "Arab"
    },
    "au": {
        "theme": "Realistic",
        "region": "OECD",
        "ethnicity": "European"
    },
    "at": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "European"
    },
    "bh": {
        "theme": "Realistic",
        "region": "GCC",
        "ethnicity": "Arab"
    },
    "be": {
        "theme": "Realistic",
        "region": "OECD",
        "ethnicity": "European"
    },
    "br": {
        "theme": "Realistic",
        "region": "OECD",
        "ethnicity": "Mestizo"
    },
    "cl": {
        "theme": "Realistic",
        "region": "OECD",
        "ethnicity": "Mestizo"
    },
    "cd": {
        "theme": "Realistic",
        "region": "AU",
        "ethnicity": "Bantu"
    },
    "cg": {
        "theme": "Realistic",
        "region": "AU",
        "ethnicity": "Bantu"
    },
    "cz": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "Slavic"
    },
    "dk": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "Nordic"
    },
    "eg": {
        "theme": "Realistic",
        "region": "AU",
        "ethnicity": "Arab"
    },
    "ee": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "Baltic"
    },
    "fi": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "Nordic"
    },
    "fr": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "European"
    },
    "id": {
        "theme": "Realistic",
        "region": "ASEAN",
        "ethnicity": "Javanese"
    },
    "ie": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "Celtic"
    },
    "it": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "European"
    },
    "kz": {
        "theme": "Realistic",
        "region": "Eurasia",
        "ethnicity": "Kazakh"
    },
    "kw": {
        "theme": "Realistic",
        "region": "GCC",
        "ethnicity": "Arab"
    },
    "lb": {
        "theme": "Realistic",
        "region": "Middle East",
        "ethnicity": "Arab"
    },
    "lu": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "European"
    },
    "my": {
        "theme": "Realistic",
        "region": "ASEAN",
        "ethnicity": "Malay"
    },
    "ma": {
        "theme": "Realistic",
        "region": "AU",
        "ethnicity": "Arab"
    },
    "nl": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "European"
    },
    "ng": {
        "theme": "Realistic",
        "region": "AU",
        "ethnicity": "Yoruba"
    },
    "no": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "Nordic"
    },
    "om": {
        "theme": "Realistic",
        "region": "GCC",
        "ethnicity": "Arab"
    },
    "pl": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "Slavic"
    },
    "pt": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "European"
    },
    "qa": {
        "theme": "Realistic",
        "region": "GCC",
        "ethnicity": "Arab"
    },
    "sa": {
        "theme": "Realistic",
        "region": "GCC",
        "ethnicity": "Arab"
    },
    "sg": {
        "theme": "Realistic",
        "region": "ASEAN",
        "ethnicity": "Chinese"
    },
    "si": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "Slavic"
    },
    "za": {
        "theme": "Realistic",
        "region": "AU",
        "ethnicity": "Bantu"
    },
    "es": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "European"
    },
    "se": {
        "theme": "Realistic",
        "region": "EU",
        "ethnicity": "Nordic"
    },
    "ch": {
        "theme": "Realistic",
        "region": "OECD",
        "ethnicity": "European"
    },
    "gb": {
        "theme": "Realistic",
        "region": "OECD",
        "ethnicity": "European"
    },
    "us": {
        "theme": "Realistic",
        "region": "OECD",
        "ethnicity": "European"
    },
    "uz": {
        "theme": "Realistic",
        "region": "Eurasia",
        "ethnicity": "Uzbek"
    }
};

export const Timelines: any[] = [
    {
        // Australia
        "hubId": "69530777-4347-4644-b2a4-1c39d23d925f",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
        ],
    },
    {   // Austria
        "hubId": "8526fd9d-edbe-412a-8bd2-d91bcb7fa102",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Bahrain
        "hubId": "b05c79d8-0b90-4ca8-8e5b-365f2b8bb199",
        "timelines": [
            "Q1 2020",
            "Q2 2020",
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Belgium
        "hubId": "a747d62b-eeb4-4aa8-a634-a5e324f221b6",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
        ],
    },
    {
        // Brazil
        "hubId": "eaaa4fe6-796b-416c-87bc-9897394dce26",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
        ],
    },
    {
        // Chile
        "hubId": "ace364cd-280b-4b97-b3ca-5763087244be",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Congo Brazzaville
        "hubId": "eb9c4690-428d-41e1-872f-dd00a9d5e38b",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Congo-Kinshasa
        "hubId": "c70353ae-57eb-4d2f-8876-bfcd07dea1d8",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Czech Republic
        "hubId": "b8ff4a79-1a16-43b9-b13b-4a6e49eb1f69",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Denmark
        "hubId": "9924eb5d-7bfd-4ae5-a6c0-276fece599b2",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Egypt
        "hubId": "50a6fdce-2ddc-46e9-b51c-f6d452ef9983",
        "timelines": [
            "Q1 2020",
            "Q2 2020",
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Estonia
        "hubId": "3e8e5bd1-16a3-4894-a186-da0cd70fe935",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Finland
        "hubId": "15de1f24-4168-43bb-a2d5-2eb2f086f20a",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // France
        "hubId": "66924389-ecbd-4322-a0e4-846ac82ac7e4",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023"
        ],
    },
    {
        // Indonesia
        "hubId": "d4f09f48-8668-4b6c-891f-473152acb9da",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Ireland
        "hubId": "72b71449-f38c-4a35-9d66-49c5a607347e",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Italy
        "hubId": "ff30bdc2-67af-4add-8a25-f4407a61b49a",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
        ],
    },
    {
        // Kazakhstan
        "hubId": "463b92ed-108e-4c2c-bc32-e6405e6d496a",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Kuwait
        "hubId": "4c7cbfd8-ff10-4cf0-a5fa-7dbc8df31bbc",
        "timelines": [
            "Q2 2020",
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
            "Q2 2024",
            "Q3 2024",
        ],
    },
    {
        // Lebanon
        "hubId": "2a7a04d1-e443-4a5d-80a4-73b6f206e66e",
        "timelines": [
            "Q1 2020",
            "Q2 2020",
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Luxembourg
        "hubId": "83555512-e914-4c44-9f57-e14d94a119d6",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Malaysia
        "hubId": "01a84fd7-cb75-4e17-859b-3b4eb83c68ef",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Morocco
        "hubId": "e9809ee1-a96c-439e-a5ea-6de6ae21e0ff",
        "timelines": [
            "Q1 2020",
            "Q2 2020",
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Netherlands
        "hubId": "e16b6516-4c08-43e9-883d-b26f034edbde",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023"
        ],
    },
    {
        // Nigeria
        "hubId": "8241c400-1698-444c-9fb5-ab6ac2b601e0",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Norway
        "hubId": "63a18e9a-918e-49cc-a2c0-b2966c18792c",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Oman
        "hubId": "1413995b-a840-4dc1-8f38-c04ad6e7352f",
        "timelines": [
            "Q1 2020",
            "Q2 2020",
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Poland
        "hubId": "894fff7a-6d05-42bf-a231-00b7f425ca32",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Portugal
        "hubId": "8d26c043-4d84-47f8-9176-8c4308c269f6",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Qatar
        "hubId": "b7ac8028-efb9-41c0-a0c3-f39cb6c84e5b",
        "timelines": [
            "Q1 2020",
            "Q2 2020",
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Saudi Arabia
        "hubId": "688713ba-882f-47c8-83a2-2af261466aec",
        "timelines": [
            "Q1 2020",
            "Q2 2020",
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Singapore
        "hubId": "9a15bff9-9b6a-4240-85bd-5bfca26059d2",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Slovenia
        "hubId": "94fa6e96-0ded-49f4-9034-57c3039b03d4",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // South Africa
        "hubId": "d01b2ab4-9569-430a-b9ae-935230d96578",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Spain
        "hubId": "36599179-f698-4ac1-86c6-7e92c82d488f",
        "timelines": [
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Sweden
        "hubId": "cb0c6886-7cc5-4c8c-a63f-14cfddaad0fa",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Switzerland
        "hubId": "a526dbce-b57f-4188-a8b1-6031b64cc7ff",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // United Arab Emirates
        "hubId": "bf1ad935-2b5b-441c-837c-62a8a036a494",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
            "Q2 2024",
            "Q3 2024",
        ],
    },
    {
        // United Kingdom
        "hubId": "3f5b7c0c-e8f8-412d-a74f-b4191fc0e70d",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023"
        ],
    },
    {
        // United States
        "hubId": "b756d4f4-152e-48ed-8442-996823f923af",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    },
    {
        // Uzbekistan
        "hubId": "ead551ff-65b3-4dab-8d98-f25ce7eb20d9",
        "timelines": [
            "Q3 2020",
            "Q4 2020",
            "Q1 2021",
            "Q2 2021",
            "Q3 2021",
            "Q4 2021",
            "Q1 2022",
            "Q2 2022",
            "Q3 2022",
            "Q4 2022",
            "Q1 2023",
            "Q2 2023",
            "Q3 2023",
            "Q4 2023",
            "Q1 2024",
        ],
    }
];